var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"gl-fade"}},[(_vm.active)?_c('div',{staticClass:"gl-overlay"},[_c('div',{staticClass:"gl-box"},[_c('div',{staticClass:"gl-spinner"},[_c('div',{staticClass:"gl-ring"}),_c('div',{staticClass:"gl-ring gl-ring--delay"})]),_c('span',{staticClass:"gl-text"},[_vm._v("Loading…")])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }